import LoadIndicator, { ILoadIndicator } from './LoadIndicator';

export type { ILoadIndicator };
export default LoadIndicator;
